import React from 'react'
import { withRouter } from "react-router-dom";
import TableComponent, { TableOp } from '../../../../components/table/TableOps';
import Remitente from './RemitenteNuevo';

class Remitentes extends TableComponent {
	componentDidMount() {
		const { params } = this.props.match;
		// console.log(this.props)
		this.tableConfig(
			{ dataUrl: `cliente-remitente/${this.props.match.params.id}/filter`, deleteUrl: 'cliente-remitente/delete', deleteField: 'cliente_rems_nombre', modUrl: `/Catalogo/Cliente/${params.id}/Remitentes`, query: { id_cliente: params.id } },
			TableOp.Table('Remitentes', [
				// { label: 'Clave', id: 'cliente_rems' },
				{ label: 'Clave', id: 'cliente_rems' },
				{ label: 'Remitente', id: 'cliente_rems_nombre' },
				{ label: 'Teléfono', id: 'cliente_rems_telefono' },
				{ label: 'Domicilio', id: 'cliente_rems_domicilio' },
				{ label: 'Colonia', id: 'colonia' },
				{ label: 'Ciudad', id: 'ciudad' },
				{ label: 'Estado', id: 'estado' },
				{ label: 'C.P.', id: 'cliente_rems_cp' },
			], [
				{ id: 'edit', icon: 'edit' },
				{ id: 'delete', icon: 'delete' },
			])
		);
		this.table();
	}

	render() {
		return (
			<div>
				<div>
					<Remitente onSave={() => { this.table() }}></Remitente>
					<this.TableRender />
				</div>
			</div>
		)
	}
}

export default withRouter(Remitentes);
